import { useEffect, useState } from 'react';

export default function ProgressiveImage ({ imgSrc, previewSrc, width, height }:any) {

    const [ usedSrc, setUsedSrc ] = useState(previewSrc);
    const [ usedEffectStyle, setUsedEffectStyle ] = useState<{}>({ filter: 'blur(1px)', clipPath: 'inset(0)' });

    useEffect(() => {
        const img = new Image();
        img.src = imgSrc;
        img.onload = () => {
            setUsedSrc(img.src);
            setUsedEffectStyle({});
        }
    }, []);

    return <img src={usedSrc} width={width} height={height} style={{ objectFit: 'cover', transition: 'filter 0.1s ease-out', ...usedEffectStyle }} />;

}